export default __webpack_public_path__ + "cff32dc86ff4cc68499679c4528b0e5b.png";